"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OrderStates;
(function (OrderStates) {
    OrderStates["AWAITING_SHIPMENT"] = "awaiting_shipment";
})(OrderStates = exports.OrderStates || (exports.OrderStates = {}));
//# sourceMappingURL=index.js.map